import { isAfter, parseISO } from 'date-fns';

export const getIsAtRisk = ({
  latestFinish,
  planEndDate,
}: {
  latestFinish: string;
  planEndDate: string;
}) => {
  const latestFinishIso = parseISO(latestFinish);
  const planEnd = parseISO(planEndDate);

  return isAfter(latestFinishIso, planEnd);
};

export const getIsDeadlineAtRisk = ({
  forecastedFinish,
  deadline,
}: {
  forecastedFinish: string | null | undefined;
  deadline: string | null | undefined;
}): boolean => {
  if (!forecastedFinish || !deadline) return false;
  return getIsAtRisk({ latestFinish: forecastedFinish, planEndDate: deadline });
};
